function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f7e44;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 1000,
  height: 1000
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "126.22 83.88 126.22 285.42 92.33 285.42 92.33 131.15 92.03 131.15 68.26 155.82 67.95 155.82 67.95 120.44 99.16 83.88 126.22 83.88"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M238,127.59v17.53c0,16.93-9.21,28.23-23.18,32.7,16.94,3.86,25,15.75,25,34.18v29.73c0,27.93-14.86,46.07-49.05,46.07-34.49,0-46.69-19.62-46.69-50.24V211.11H175V240c0,11.89,4.15,19.6,15.76,19.6,10.39,0,15.14-7.42,15.14-18.13V208.14c0-10.71-4.75-16.35-16.63-16.35H175V165.93h12.79c11,0,18.11-5.66,18.11-16.35v-21.7c0-11-3.85-18.13-14.55-18.13s-14.56,7.13-14.56,19.61v20.51H145.83V132c0-29.73,12.19-50.54,47.27-50.54,31.22,0,44.89,17.55,44.89,46.09"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M867.09,626C840.74,589.09,721.56,441.55,500,441.55S159.32,589.09,132.93,626c-1.12,1.58-2.09,3-2.87,4.11.78,1.19,1.75,2.55,2.87,4.15C159.32,671.23,278.46,818.78,500,818.78S840.74,671.23,867.09,634.3c1.15-1.6,2.1-3,2.85-4.15q-1.12-1.74-2.85-4.11m-490.64-91.2c2-2.93,8.63-11.29,9.43-12.35,1.71-2.2,5.1-2.65,7.47-3.07s5.49.87,5.87,2.64-.91,8.63-2.07,9.81c-3.25,3.37-11.71,8.13-16.37,7.38-3.61-.55-5-3.34-4.33-4.41m-7.92,15.74c.35-.42.67-.76.8-.93,2.79-3.18,8.34-3.86,12.17-4.46s9,1.28,9.58,3.83-9.63,7.2-11.51,9c-5.33,4.91-13.67,14.91-18.55,16a5.86,5.86,0,0,1-4-.41,152.9,152.9,0,0,1,11.5-23m82.91,170.08c-3,11.8-6.5,16.05-9.48,19.77s-14,8.57-21,8.05-8-19.25-8-28.89c0-3.32-4.71,6.54-7.17-13.51-1.57-12.83-9.81,1.34-10.39-7.22s-4.7-6.84-9-12.18-9.68.52-15.7,3.22-3.52,4.06-12,1.38c-.22-.07-.33-.13-.54-.21A153.79,153.79,0,0,1,345.93,631c0-5.21.28-10.34.77-15.4a9.2,9.2,0,0,1,.95-1.44c8.16-9.66,8-11.92,8-11.92l9-3.12s14.42,2.22,25.28,6.31c8.95,3.35,23,10.94,31.23,7.6,5.93-2.44,10.56-5.68,10-10.61-.66-6.19-5.54-7.66-11.44-3.49-2.17,1.54-6.81-9.33-10.45-8.77s4.5,12.76,1.42,13.28-9.31-12.74-10.37-14.89-5.85-7.46-10.16-3.4c-9.1,8.65-23.88,8.12-26.85,10.35-9,6.76-11.42-2.23-11.22-7.7.36-1.25.73-2.51,1.13-3.75,2.95-3.25,13.54-4.33,17.18-1.91,4,2.67,6.86-.68,8.42-2.3s1-4.15,0-6.27,2-3.72,4.06-4.27,8.95-5.37,11.7-7,17-3.33,23.43-.13a12.42,12.42,0,0,0,15.41-3.11,41.24,41.24,0,0,1,11.19-9.33c2.24-1-5.51-8.27-11.87-.39s-9.63,8.56-12.63,8.56-20.82-4.44-23-10.07,5.58-9.84,12.15-13,24.57-3.09,29.17-4.13c9.35-2.05,21.31-6.75,27.33-2.65s-25.15,11.12-14.91,16.65c3.64,2,20.1-9.47,25.75-12.41,13.27-6.84-12.87-9.1-9.48-23,3.83-15.72-32.07-9.64-50-8.3a154.3,154.3,0,0,1,233.18,93.93,25.36,25.36,0,0,1-.75,7.15c-1.4,5.56-12,10.34-18.07,1.39-1.56-2.26-8.18-8.51-8,2.18s10.4,11.79.53,18.21-11.66,4.87-16.22,6.49-9,12.63-7.87,18.52,15.17,22,4.73,21.32c-2.45-.19-20.89-12.78-23.93-20.88-3.22-8.53-6.72-16.87-9.21-23.3s-9-8-14.54-4.27,1.53,7.51-2.42,15.55-6.76,15.19-12.55,8.56c-15.07-17.26-37-8.75-40.39-28-1.85-10.41-10.82-9.41-18.32-15.31s-11.73-9-13-4.81c-1.11,3.73,23.59,23.32,25.35,28.33,2.63,7.46-7.39,14-14.73,15.8s-10.52-4.11-17.72-11.61-10.33-12.82-10.83-6.94c-.72,8.49,6.83,21,14.15,25.62,6.25,3.95,13.25,5.74,11.22,12.16s0,2.8-7,9.72-8.34,9.19-7.83,18.8-2,10.19-3.51,18.2-5,1.08-8,12.83M617,659.12c5.18-.42,13,6.77,9.93,9.53s-10.81,1.74-14.72-1.32,2.45-8,4.79-8.21m-6.57-4.74c-1.66-.62-3.13-2.2-4.39-6s1.93-6,5-4.43,7.28,6.33,7.28,8.85-6.23,2.23-7.93,1.56m-68.11-.27c-3.05,2.72-10.85,1.72-14.75-1.32s2.46-8,4.78-8.21c5.19-.47,13,6.79,10,9.53m-63,30.65c-2.12,3.47-7.93,29.42-11.82,26.4s1.58-30.1,2.7-32.16c6.1-11.18,19.28-10.63,9.12,5.76m21,100.58a154.27,154.27,0,0,1-43.37-6.21,6.35,6.35,0,0,1-1.87-7.54c4.77-12.45,19-17.33,30.22-18.41,25-2.44,57.92,16.25,63.15,13.23s15.83-16.77,31.35-16.19c10.6.41,10.52,2.19,14.08,3.53a153.73,153.73,0,0,1-93.56,31.59m108.85-44.92a25.79,25.79,0,0,1-4.84-1.79c-8.43-4.29-7.42,2.56-11.56,1s4.67-11.15-7.77-3-9.05-1.26-14.45-15,6.22-29.43,16-33c13.41-4.85,21.73-5.84,28-7.39,18.54-4.63,22.46-15.63,25.82-8.94.64,1.25,1.25,2.45,1.81,3.57A24.37,24.37,0,0,1,644.51,686a154.48,154.48,0,0,1-35.38,54.44m42.28-77.91c-4.14-1.13-21.47-25.09-7.77-40.85,2.28-2.59-4.6-10.22-2.72-10.37,7.5-.58,11.48,4.07,13.45,10.77.15,3,.27,5.94.27,9a155.68,155.68,0,0,1-3.23,31.5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M319.1,145.6V105.23c0-13,6.15-22.52,20.92-22.52,15.51,0,19.82,8.61,19.82,20.92v9.85H347v-11c0-5.17-1.72-8.12-6.77-8.12S333.13,98,333.13,103v44.8c0,5,2.09,8.61,7.14,8.61s6.77-3.2,6.77-8.12V132.92h12.8v14.4c0,11.94-4.92,20.8-19.82,20.8S319.1,158.52,319.1,145.6Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M368.69,83.69h14v72h16.74v11.45H368.69Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M407.07,83.69h14v83.45h-14Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M470.21,113h-.37l-9.47,54.15h-6.53L443.38,113h-.25v54.15H431.57V83.69h16.36l9.11,47h.13l8.12-47H483v83.45H470.21Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M490,167.14l15.76-83.45h16l15.88,83.45h-14.4l-2.59-15.27H505.77l-2.47,15.27Zm17.6-26.46h11.21l-5.54-33.48h-.13Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M535.77,83.69h37.3V95.14H561.5v72H547.34v-72H535.77Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M580.81,83.69h33.48V95.14H594.84V119h13.91v11.32H594.84v25.35h19.45v11.45H580.81Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M316.65,285.42,332.41,202h16l15.88,83.44h-14.4l-2.59-15.26H332.41l-2.47,15.26ZM334.25,259h11.21l-5.54-33.47h-.13Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M368.32,263.89V223.52c0-13.05,6.16-22.52,20.93-22.52,15.5,0,19.81,8.61,19.81,20.92v9.84h-12.8V220.81c0-5.17-1.72-8.12-6.77-8.12s-7.14,3.57-7.14,8.61v44.8c0,5,2.1,8.62,7.14,8.62s6.77-3.2,6.77-8.13V251.21h12.8v14.4c0,11.94-4.92,20.8-19.81,20.8S368.32,276.81,368.32,263.89Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M414,202h37.3v11.45H439.69v72H425.53v-72H414Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M459,202h14v83.44H459Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M482.37,263.89V223.52c0-13.05,6.41-22.52,21.17-22.52s21.3,9.47,21.3,22.52v40.37c0,12.92-6.41,22.52-21.3,22.52S482.37,276.81,482.37,263.89Zm28.44,2.21V221.3c0-5-2.22-8.61-7.27-8.61s-7.14,3.57-7.14,8.61v44.8c0,5,2.22,8.62,7.14,8.62S510.81,271.15,510.81,266.1Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M545.86,233v52.43H534.05V202h13.79L563,249.85V202h11.7v83.44H562.36Z"
});

var SvgColorGoal13 = function SvgColorGoal13(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorGoal13, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Color_Goal_13.bf9936c5.svg";
export { ForwardRef as ReactComponent };